// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoaderProvider_wrapper__1kLlU"};